export default {
  返回: '返回',
  点击退出全屏模式: '点击退出全屏模式',
  点击切换全屏模式: '点击切换全屏模式',
  语言: '语言',
  清除缓存: '清除缓存',
  复制租户: '复制租户',
  退出: '退出',
  搜索布局名称: '搜索布局名称',
  分配布局: '分配布局',
  新建布局: '新建布局',
  列表页布局: '列表页布局',
  新建页布局: '新建页布局',
  编辑页布局: '编辑页布局',
  详情页布局: '详情页布局',
  布局名称: '布局名称',
  布局类型: '布局类型',
  关联视图: '关联视图',
  视图名称: '视图名称',
  资源库: '资源库',
  请输入布局名称: '请输入布局名称',
  选择字段: '选择字段',
  可选字段: '可选字段',
  列表页字段: '列表页字段',
  拖到这里: '拖到这里',
  置顶固定字段: '置顶固定字段',
  以上指标将横向固定: '以上指标将横向固定',
  筛选字段: '筛选字段',
  下拉搜索字段: '下拉搜索字段',
  列表页排序规则: '列表页排序规则',
  新增排序规则: '新增排序规则',
  升序: '升序',
  降序: '降序',
  请输入搜索内容: '请输入搜索内容',
  添加新分组: '添加新分组',
  至少添加一个分组: '至少添加一个分组！',
  请完善组件的必填内容: '请完善组件的必填内容',
  请在子表单中至少添加一个自定义字段: '请在子表单中至少添加一个自定义字段',
  每个布局中最多只能添加10个子表单: '每个布局中最多只能添加10个子表单',
  组件: '组件',
  关联对象表格: '关联对象表格',
  关联记录: '关联记录',
  查询记录: '查询记录',
  快速创建: '快速创建',
  已完成关联主键创建: '已完成关联主键创建',
  关联对象字段: '关联对象字段',
  外链容器: '外链容器',
  未命名分组: '未命名分组',
  示例: '示例',
  属于当前值: '属于当前值',
  添加显示条件: '添加显示条件',
  添加必填条件: '添加必填条件',
  数据范围条件配置: '数据范围条件配置',
  条件配置: '条件配置',
  数据条件设置不可为空: '数据条件设置不可为空',
  详情标题: '详情标题',
  请选择标题: '请选择标题',
  点击配置是否展示商机阶段: '点击配置是否展示商机阶段',
  组件已启用: '组件已启用',
  未启用该组件: '未启用该组件',
  未启用协作人: '未启用协作人',
  点击配置是否展示协作人: '点击配置是否展示协作人',
  点击配置是否展示动态记录: '点击配置是否展示动态记录',
  页签设置: '页签设置',
  是否展示: '是否展示',
  页签名称: '页签名称',
  请输入页签名称: '请输入页签名称',
  显示条件: '显示条件',
  请选择显示条件: '请选择显示条件',
  默认可见: '默认可见',
  满足条件可见: '满足条件可见',
  添加条件: '添加条件',
  关联对象: '关联对象',
  请选择关联对象: '请选择关联对象',
  请输入标题名称: '请输入标题名称',
  至少保留一项可用于在表格内展示的字段: '至少保留一项可用于在表格内展示的字段',
  字段配置: '字段配置',
  列表字段: '列表字段',
  列表字段配置: '列表字段配置',
  已配置字段个数: '已配置：{number}个字段',
  标题名称: '标题名称',
  快捷按钮: '快捷按钮',
  表格字段配置: '表格字段配置',
  展示字段配置: '展示字段配置',
  数据范围: '数据范围',
  请选择数据范围: '请选择数据范围',
  数据条件范围配置: '数据条件范围配置',
  关联主键: '关联主键',
  请选择关联主键: '请选择关联主键',
  显示字段: '显示字段',
  请选择显示字段: '请选择显示字段',
  请选择弹窗显示字段: '请选择弹窗显示字段',
  字段提示: '字段提示',
  请输入字段提示信息: '请输入字段提示信息',
  附加说明: '附加说明',
  请输入附加说明信息: '请输入附加说明信息',
  是否展示整行: '是否展示整行',
  是否必填: '是否必填',
  请选择是否必填: '请选择是否必填',
  编辑页可修改: '编辑页可修改',
  编辑规则设置: '编辑规则设置',
  可编辑已有记录: '可编辑已有记录',
  可删除已有记录: '可删除已有记录',
  可新增记录: '可新增记录',
  可插入记录: '可插入记录',
  默认提示文本: '默认提示文本',
  请输入默认提示文本: '请输入默认提示文本',
  '设为只读的字段将不允许被用户直接编辑。但仍可以在自动化流程或导入时填写或更新': '设为只读的字段将不允许被用户直接编辑。但仍可以在自动化流程或导入时填写或更新',
  '设为隐藏的字段将不会显示。但仍可以在自动化流程或导入时填写或更新': '设为隐藏的字段将不会显示。但仍可以在自动化流程或导入时填写或更新',
  是否整行展示: '是否整行展示',
  默认值: '默认值',
  非必填: '非必填',
  必填: '必填',
  在某条件下必填: '在某条件下必填',
  不展示默认值: '不展示默认值',
  展示统一默认值: '展示统一默认值',
  自定义: '自定义',
  查询他表: '查询他表',
  计算公式: '计算公式',
  查询他表配置: '查询他表配置',
  公式配置: '公式配置',
  请选择表单: '请选择表单',
  高级筛选: '高级筛选',
  请选择条件: '请选择条件',
  查询到多条时: '查询到多条时',
  设置排序: '设置排序',
  当前用户: '当前用户',
  当前用户所属部门: '当前用户所属部门',
  全部数据: '全部数据',
  条件范围数据: '条件范围数据',
  新增页签: '新增页签',
  请输入分组名称: '请输入分组名称',
  已选字段: '已选字段',
  该页面不支持配置: '该页面不支持配置',
  修改密码: '修改密码',
  切换登录身份: '切换登录身份',
  容联设置: '容联设置',
  欢迎登录烽火: '欢迎登录烽火',
  '温馨提示：为了您的账号考虑，请尽快修改登录密码~': '温馨提示：为了您的账号考虑，请尽快修改登录密码~',
  暂不提示: '暂不提示',
  稍后再说: '稍后再说',
  立即修改: '立即修改',
  智书: '智书',
  赋值规则: '赋值规则',
  规则配置: '规则配置',
  添加规则: '添加规则',
  的: '的',
  赋值给本对象的: '赋值给本对象的',
  用户填写: '用户填写',
  用户修改: '用户修改',
  用户清空: '用户清空',
  '字段时，【逻辑赋值】自动覆盖【手动填写】': '字段时，【逻辑赋值】自动覆盖【手动填写】',
  '字段时，将根据赋值规则，对所有字段重新赋值': '字段时，将根据赋值规则，对所有字段重新赋值',
  '字段时，将根据赋值规则，对所有字段同时清空': '字段时，将根据赋值规则，对所有字段同时清空',
  '字段时，已赋值字段不清空': '字段时，已赋值字段不清空',
  切换语言: '切换语言',
  新增: '新增',
  编辑: '编辑',
  多层级表格: '多层级表格',
  开启多层级表格: '开启多层级表格',
  添加多层级表格: '添加多层级表格',
  已添加二级表格: '已添加二级表格',
  已添加三级表格: '已添加三级表格',
  '请在查询记录中添加多层级表格！': '请在查询记录中添加多层级表格！',
  '请配置多层级表格的关联对象!': '请配置多层级表格的关联对象!',
  '删除二级表格将同步删除已配置的三级表格!': '删除二级表格将同步删除已配置的三级表格!',
  从新建页布局复制: '从新建页布局复制',
  从编辑布局复制: '从编辑布局复制',
  '不复制，直接新建': '不复制，直接新建',
  请选择: '请选择',
  请选择布局: '请选择布局',
  冻结: '冻结',
  取消冻结: '取消冻结',
  批量修改: '批量修改',
  请选择需要修改的字段: '请选择需要修改的字段',
  修改为: '修改为',
  新值: '新值',
  清空内容: '清空内容',
  请完善修改后的值: '请完善修改后的值',
  '你确定要修改全部数据吗？': '你确定要修改全部数据吗？',
  此操作将修改全部: '此操作将修改全部',
  '条数据。数据修改后不可恢复，请谨慎操作': '条数据。数据修改后不可恢复，请谨慎操作',
  '此数据存在重复，请检查后重试': '此数据存在重复，请检查后重试',
  置顶: '置顶',
  取消置顶: '取消置顶',
  复制到其他布局: '复制到其他布局',
  请选择页签名称: '请选择页签名称',
  请选择目标页签: '请选择目标页签',
  复制到当前布局: '复制到当前布局',
  复制到当前页签: '复制到当前页签',
  展示当前时间: '展示当前时间',
  复制到其他页签: '复制到其他页签',
  请选择目标布局: '请选择目标布局',
  目标布局: '目标布局',
  移动到分组: '移动到分组',
  目标页签: '目标页签',
  移动: '移动',
  复制到其他布局页签: '复制到其他布局页签',
  恢复: '恢复',
  确定删除当前字段以及该字段对应表单数据: '确定删除当前字段以及该字段对应表单数据',
  确定恢复当前字段以及该字段对应表单数据: '确定恢复当前字段以及该字段对应表单数据',
  请确定最新的字段属性: '请确定最新的字段属性',
  布局字段列数: '布局字段列数',
  字段宽度: '字段宽度',
  批量恢复: '批量恢复',
  检索定位: '检索定位',
  请选择字段宽度: '请选择字段宽度',
  '确定批量恢复所选字段以及所选字段对应表单数据？': '确定批量恢复所选字段以及所选字段对应表单数据？',
  显示设置: '显示设置',
  操作设置: '操作设置',
  '如不指定，默认按照数据创建时间降序排序': '如不指定，默认按照数据创建时间降序排序',
  显示列: '显示列',
  列表下拉搜索: '列表下拉搜索',
  多层级列表: '多层级列表',
  默认排序规则: '默认排序规则',
  添加排序规则: '添加排序规则',
  搜索字段配置: '搜索字段配置',
  列表页展示至少需保留一个非子表单字段: '列表页展示至少需保留一个非子表单字段',
  以上字段已冻结: '以上字段已冻结',
  '最多冻结10个非子表单类型的字段!': '最多冻结10个非子表单类型的字段!',
  摘要区暂无内容: '摘要区暂无内容',
  暂无内容: '暂无内容',
  校验: '校验',
  属性: '属性',
  新建页: '新建页',
  编辑页: '编辑页',
  详情页: '详情页',
  列表页: '列表页'
};
